import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3b51034d")

_pushScopeId("data-v-3b51034d")
const _hoisted_1 = { class: "your-data" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ProgressIndicator = _resolveComponent("ProgressIndicator")!
  const _component_FormRow = _resolveComponent("FormRow")!
  const _component_YourDataForm = _resolveComponent("YourDataForm")!
  const _component_PoweredBy = _resolveComponent("PoweredBy")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withId(() => [
        _createVNode(_component_ProgressIndicator, {
          steps: 4,
          currentStep: 2
        })
      ]),
      _: 1
    }),
    _createVNode(_component_YourDataForm),
    _createVNode(_component_FormRow, null, {
      default: _withId(() => [
        _createVNode(_component_PoweredBy)
      ]),
      _: 1
    })
  ]))
})